function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { forwardRef, useEffect } from 'react';
import { useFormField } from 'formydable';
import InputCore from './InputCore';
const Input = /*#__PURE__*/forwardRef(({
  mutateOnChange,
  wrappedValueOnArray,
  defaultValue,
  ...props
}, ref) => {
  const {
    label,
    value,
    rules,
    name
  } = props;
  const {
    formState,
    formUpdate,
    formRegistry,
    setFieldValue
  } = useFormField();
  const state = formState(name);
  useEffect(() => {
    return formRegistry({
      label: label || name,
      value: wrappedValueOnArray ? value ? [value] : [] : props.nullableValue ? value : value === null ? undefined : value,
      defaultValue,
      rules,
      name
    }); // eslint-disable-next-line
  }, [value, rules]);
  const handleChange = mutateOnChange ? (...args) => {
    const {
      name,
      value
    } = mutateOnChange(...args);
    setFieldValue(name, value);
  } : formUpdate;
  return /*#__PURE__*/React.createElement(InputCore, _extends({
    ref: ref
  }, props, {
    name: name,
    state: state,
    onChange: handleChange
  }));
});
export default Input;